import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getTranslation } from "orion-components/i18n";
import { CBMenu } from "orion-components/CBComponents";
import { SelectMultipleDialog } from "orion-components/SharedComponents";

const WidgetMenu = ({ addAlertingZonesToEntity, alertingZones, shapes }) => {
	const selectedAlertLines = shapes?.filter((shape) => shape.entityData.geometry.type === "LineString" && !alertingZones.includes(shape.id)) || [];
	const selectedAlertZones = shapes?.filter((shape) => shape.entityData.geometry.type !== "LineString" && shape.entityData.geometry.type !== "Point" && !alertingZones.includes(shape.id)) || [];
	const dialogItems = [...selectedAlertLines, ...selectedAlertZones];

	const [dialog, setDialog] = useState("");
	const [dialogSelectedItemsId, setDialogSelectedItemsId] = useState([]);

	useEffect(() => {
		setDialogSelectedItemsId(alertingZones);
	}, [alertingZones]);

	const getSelectedOptions = (items) => {
		let selectedIds = [...dialogSelectedItemsId];

		items.forEach((data) => {
			// Check if the ID is already in the selected array
			if (selectedIds.includes(data.id)) {
				// Remove the ID by filtering it out
				selectedIds = selectedIds.filter((id) => id !== data.id);
			} else {
				// Add the new ID to the selected array
				selectedIds.push(data.id);
			}
		});
		setDialogSelectedItemsId(selectedIds);
		addAlertingZonesToEntity(selectedIds);
	};

	const _closeDialog = () => {
		setDialog("");
	};


	const menuItems = [
		{
			label: "global.profiles.widgets.alarmingZones.addAlarmingZones",
			onClick: () => {
				setDialog("alerting-zones-dialog");
			},
			disabled: false,
			showMenuItem: true
		}
	];

	return (
		<>
			<CBMenu menuItems={menuItems} />
			{dialog === "alerting-zones-dialog" && (
				<SelectMultipleDialog
					open={dialog === "alerting-zones-dialog"}
					closeDialog={_closeDialog}
					dialogItems={dialogItems}
					dialogTitle={getTranslation("global.profiles.widgets.alarmingZones.chooseAlarmingZones")}
					getSelectedOptions={getSelectedOptions}
					dialogItemIcon="shapes"
					dialogItemTextPropPath={"entityData.properties.name"}
					dialogSelectedItemsId={dialogSelectedItemsId}
				/>
			)}
		</>
	);
};

WidgetMenu.propTypes = {
	alertingZones: PropTypes.array.isRequired,
	addAlertingZonesToEntity: PropTypes.func,
	shapes: PropTypes.array
};

WidgetMenu.defaultProps = {
	addAlertingZonesToEntity: () => { },
	shapes: []
};

export default WidgetMenu;
